module.exports = __webpack_public_path__ + "img/ng.bde71aad.svg";